import { create } from 'zustand';

interface MacroMarketState {
  btcDominance: number;
  ethDominance: number;
  marketRegime: string;
  marketRegimeExplanation?: string;
  fearAndGreed?: {
    score: number;
    label: string;
  };
}

export const useMacroMarketStore = create<MacroMarketState & { fetchMacroMarket: () => Promise<void> }>((set) => ({
  btcDominance: 0,
  ethDominance: 0,
  marketRegime: '',
  marketRegimeExplanation: '',
  fearAndGreed: undefined,
  fetchMacroMarket: async () => {
    try {
      const btcRes = await fetch('/api/market/btc-dominance/latest');
      const btcData = await btcRes.json();
      const ethRes = await fetch('/api/market/eth-dominance/latest');
      const ethData = await ethRes.json();
      set({
        btcDominance: btcData.dominance || 0,
        ethDominance: ethData.dominance || 0,
        // Optionally set marketRegime, marketRegimeExplanation, fearAndGreed if available
      });
    } catch (e) {
      // handle error
    }
  },
}));